// src/pages/admin/AdminLayout.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AdminDashboard from "./AdminDashboard";
import ProductManagement from "./ProductManagement";
import UserManagement from "./UserManagement";
import ContactManagement from "./ContactManagement";

export default function AdminLayout() {
  const [activeTab, setActiveTab] = useState("orders");
  const { user } = useAuth();
  const isSuperAdmin = user?.role === "superadmin";

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center gap-4">
              <h1 className="text-2xl font-bold text-gray-900">
                Admin Panel {isSuperAdmin && <span className="text-purple-600 text-sm">(Super Admin)</span>}
              </h1>
              <Link
                to="/"
                className="text-sm text-purple-600 hover:text-purple-700 font-medium"
              >
                ← Back to Store
              </Link>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex gap-1 border-b overflow-x-auto">
            <button
              onClick={() => setActiveTab("orders")}
              className={`px-6 py-3 font-medium transition whitespace-nowrap ${
                activeTab === "orders"
                  ? "text-purple-600 border-b-2 border-purple-600"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              📦 Orders
            </button>
            <button
              onClick={() => setActiveTab("products")}
              className={`px-6 py-3 font-medium transition whitespace-nowrap ${
                activeTab === "products"
                  ? "text-purple-600 border-b-2 border-purple-600"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              🛍️ Products
            </button>
            <button
              onClick={() => setActiveTab("messages")}
              className={`px-6 py-3 font-medium transition whitespace-nowrap ${
                activeTab === "messages"
                  ? "text-purple-600 border-b-2 border-purple-600"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              💬 Messages
            </button>
            {isSuperAdmin && (
              <button
                onClick={() => setActiveTab("users")}
                className={`px-6 py-3 font-medium transition whitespace-nowrap ${
                  activeTab === "users"
                    ? "text-purple-600 border-b-2 border-purple-600"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                👥 Users & Admins
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      <div>
        {activeTab === "orders" && <AdminDashboard />}
        {activeTab === "products" && <ProductManagement />}
        {activeTab === "messages" && <ContactManagement />}
        {activeTab === "users" && isSuperAdmin && <UserManagement />}
      </div>
    </div>
  );
}